import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance/axiosInstance";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import { AdminUserMembersResponse } from "../contracts/AdminUserMembersResponse";
import { mapResponseToAdminUserMembers } from "../mappers/AdminUserMembersMapper";
import { AdminUserMembers } from "../models/AdminUserMembers";

/** The members of an instructor's organization (back office). */
export const fetchAdminUserMembers = createAsyncThunk<
  AdminUserMembers,
  string,
  { rejectValue: ApiErrorResponse }
>("admin/fetchUserMembers", async (instructorId, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get<AdminUserMembersResponse>(
      `/admin/users/${instructorId}/members`
    );
    return mapResponseToAdminUserMembers(response.data);
  } catch (error) {
    return rejectWithValue(toApiError(error, "Failed to load the members"));
  }
});
